import {
  MockMap,
} from '@ama-sdk/core';
import {
  disruptedOneway1Adt1infVipEcoMock,
} from './mocks/self-reaccomodation';


/**
 * AdapterMap contains the scenario (key) and the MockMap associated to each scenario.
 */
export const mockMaps: {[scenario: string]: MockMap} = {
  disruptedOneway1Adt1infVipEcoMock,
};
